import React from 'react'
import PropTypes from 'prop-types'

import { useMoverQuery } from '../../hook'

import { Card } from '../../../index'
import RouteLink from '../../../routeLink/routeLink.component'
import { defaultIfEmpty, inMillions, MOVER_TYPE, THEMES, getLocalizedCurrency } from '../../../../utils'
import { get } from 'lodash'
const propTypes = {
  dataId: PropTypes.string,
  theme: PropTypes.oneOf([THEMES.DARK, THEMES.LIGHT]),
  entityId: PropTypes.string.isRequired,
  entityType: PropTypes.string.isRequired
}

/**
 * Top Buys Component
 * @param props
 */
function TopBuys (props) {
  const { dataId, theme, entityId, entityType } = props

  const { loading, data } = useMoverQuery({
    variables: {
      entityId,
      entityType,
      moverType: MOVER_TYPE.BUY,
      currencyCode: getLocalizedCurrency()
    }
  })

  const movers = get(data, 'mover.items', [])
  const total = get(data, 'mover.sum', null)
  const hasMovers = !loading && movers.length

  /**
   * Render Top Buys Component
   */
  return (
    <Card
      dataId={`${dataId}TopBuysCard`}
      className='card--medium'
      theme={theme}
      isLoading={loading}
      title={
        <>
          <div className='card_list-label'>
            Top Buys <span className='card_header-note'>{`3 Month Mkt Value Chg (MM ${getLocalizedCurrency()})`}</span>
          </div>
          <div className='card_list-value card_list-value--positive'>{hasMovers ? inMillions(total, 2) : null}</div>
        </>
      }
    >
      {(!loading && !hasMovers)
        ? 'No data available'
        : (movers || []).map((item, index) => {
          const { tickerId, securityName, marketValueChange } = item
          return (
            <RouteLink key={tickerId || `buy_${index}`} className='card_list' to={tickerId && `/security/${tickerId}`}>
              <div className='card_list-label'>{defaultIfEmpty(securityName)}</div>
              <div className='card_list-value card_list-value--positive'>
                {inMillions(marketValueChange, 2)}
              </div>
            </RouteLink>
          )
        })}
    </Card>
  )
}

TopBuys.propTypes = propTypes

export default TopBuys
